import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

const PrivacyData = () => {
    const navigator = useNavigate();
    return (
        <>
            <Helmet>
                <title>Privacy | TLK</title>
            </Helmet>
            {/* start: privacy data page */}
            <div className="legal-page">
                <header className="legal-header">
                    <div className="legal-header-left">
                        <button className="legal-back-btn" onClick={() => navigator(-1)}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-arrow-left w-6 h-6"
                            >
                                <path d="m12 19-7-7 7-7" />
                                <path d="M19 12H5" />
                            </svg>
                        </button>
                        <div className="legal-title">
                            <span className="legal-bar"></span>
                            <h1>Privacy &amp; Data</h1>
                        </div>
                    </div>
                </header>

                <main className="legal-main">
                    <div className="legal-content">

                        <section className="legal-card">
                            <h2>
                                <span className="legal-num">1.</span> Introduction
                            </h2>
                            <p>
                                We value your privacy and are committed to protecting your personal data.
                                This Privacy Policy explains how we collect, use, and safeguard your
                                information when you use our website and services.
                            </p>
                        </section>

                        <section className="legal-card">
                            <h2>
                                <span className="legal-num">2.</span> Information We Collect
                            </h2>
                            <ul className="legal-list">
                                <li><span className="legal-dot"></span><span>Personal information (name, email address, phone number)</span></li>
                                <li><span className="legal-dot"></span><span>Account and profile data</span></li>
                                <li><span className="legal-dot"></span><span>Usage data (pages visited, session duration)</span></li>
                                <li><span className="legal-dot"></span><span>Cookies and tracking technologies</span></li>
                            </ul>
                        </section>

                        <section className="legal-card">
                            <h2>
                                <span className="legal-num">3.</span> How We Use Your Information
                            </h2>
                            <ul className="legal-list">
                                <li><span className="legal-dot"></span><span>Provide and maintain our services</span></li>
                                <li><span className="legal-dot"></span><span>Improve website performance and experience</span></li>
                                <li><span className="legal-dot"></span><span>Send important updates or notifications</span></li>
                                <li><span className="legal-dot"></span><span>Ensure security and prevent fraud</span></li>
                            </ul>
                        </section>

                        <section className="legal-card">
                            <h2>
                                <span className="legal-num">4.</span> Data Protection
                            </h2>
                            <p>
                                We implement appropriate technical and organizational measures to protect
                                your personal data from unauthorized access, alteration, disclosure, or
                                destruction.
                            </p>
                        </section>

                        <section className="legal-card">
                            <h2>
                                <span className="legal-num">5.</span> Third-Party Services
                            </h2>
                            <p>
                                We may share your data with trusted third-party providers to operate our
                                services. These providers are contractually obligated to keep your data
                                secure.
                            </p>
                        </section>

                        <section className="legal-card">
                            <h2>
                                <span className="legal-num">6.</span> Your Rights
                            </h2>
                            <p>
                                You have the right to access, update, or request deletion of your personal
                                information. Contact us to exercise your rights.
                            </p>
                        </section>

                        <section className="legal-card">
                            <h2>
                                <span className="legal-num">7.</span> Contact Us
                            </h2>
                            <p className="legal-lead">
                                If you have questions regarding this Privacy Policy, please contact:
                            </p>
                            <p><strong>support@tlknow.ai</strong></p>
                        </section>

                    </div>
                </main>
            </div>
            {/* end: privacy data page */}
        </>
    );
}

export default PrivacyData;